import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-slate-950 font-sans text-slate-100 antialiased" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3rc9e8848zfxr" />
      <main data-id="element-2" data-mp="3rbrakqf99zft">
        <Hero data-id="element-3" data-mp="3rbzq6q2rjiup" />
        <SocialProof data-id="element-4" data-mp="3rdkg22e4udm8" />
        <Testimonials data-id="element-5" data-mp="3rd17vdeab3le" />
        <ProblemSection data-id="element-6" data-mp="5yimri0b7dt" />
        <SystemSection data-id="element-7" data-mp="67znpl2q47d" />
        <ModulesSection data-id="element-8" data-mp="4n725ibkvc5" />
        <BonusSection data-id="element-9" data-mp="82k72sfnuax" />
        <UrgencySection data-id="element-10" data-mp="2zl3dbpgpde7f" />
        <PricingSection data-id="element-11" data-mp="2zlv8x0aavbxp" />
        <MoreResults data-id="element-12" data-mp="2zmo4d53t6f0j" />
        <GuaranteeSection data-id="element-13" data-mp="2zn6cp03qwjot" />
        <FAQ data-id="element-14" data-mp="33mf0loc3tncg" />
        <ClosingSection data-id="element-15" data-mp="33lwyib2rgewm" />
        <SummaryTable data-id="element-16" data-mp="33ngiabnml835" />
        <FinalCta data-id="element-17" data-mp="33orjq4tlm3r3" />
      </main>
      <Footer data-id="element-18" data-mp="38m1f013o59mu" />
      <PurchaseNotification data-id="element-19" data-mp="38li7zffk45nl" />
    </div>;
}